/**
 * @file Statuts du magasin de session et motifs de fin de session.
 * @module packages.common.stores.sessionStatus
 *
 * Ces valeurs se comparent par égalité stricte dans le magasin, le provider et
 * les écrans. Écrites à la main de chaque côté, une faute de frappe ne casse
 * aucune compilation : elle rend simplement une condition toujours fausse, et
 * l'utilisateur reste sur un écran de chargement sans fin. Elles vivent donc
 * ici, et nulle part ailleurs.
 */

/** États du chargement de la session. */
export const SESSION_STATUS = Object.freeze({
  /** Rien n'a encore été tenté : le provider déclenche un chargement. */
  IDLE: 'idle',
  /** Chargement en cours, écran de chargement affiché. */
  LOADING: 'loading',
  /** Session chargée, l'application peut s'afficher. */
  READY: 'ready',
  /** Le serveur n'a pas répondu : rien ne dit que la session est en cause, on retente. */
  UNAVAILABLE: 'unavailable',
  /** Refus dont l'utilisateur doit être averti, avec une action à faire. */
  ERROR: 'error',
  /** Terminal : la session est finie, une page de connexion arrive. */
  CLOSED: 'closed',
});

/**
 * Motifs de fin de session.
 *
 * Ils ne se traitent pas pareil : une session expirée sera reprise par la même
 * personne, un départ volontaire annonce presque toujours un changement de main.
 */
export const TERMINATION_REASON = Object.freeze({
  /** Session refusée par le serveur. */
  EXPIRED: 'expired',
  /** Départ volontaire de l'utilisateur. */
  LOGOUT: 'logout',
});
